import { render, staticRenderFns } from "./QAgentLicensingSureLc.vue?vue&type=template&id=aff1d042&"
import script from "./QAgentLicensingSureLc.vue?vue&type=script&lang=js&"
export * from "./QAgentLicensingSureLc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports